import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getGhollaks } from "services/ghollak.routes";
import Loading from "../../components/Loading";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import queryString from "../../utils/queryString";
import GhollakTable from "./GhollakTable";

export default function Ghollaks() {
    const [searchParams] = useSearchParams()

    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [ghollaks, setGhollaks] = useState([]);
    const [searchInfo, setSearchInfo] = useState({ all: true });
    const [trigger, setTrigger] = useState(null);
    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        if (name === "isLock" || name === "all") {
            setSearchInfo({ ...searchInfo, [name]: checked });
        } else
            setSearchInfo({ ...searchInfo, [name]: value });
    };

    useEffect(() => {
        setLoading(true);
        let query = {
            cursor: cursor === null ? null : cursor,
            admin: 1,
            name: searchInfo?.name ? searchInfo.name : null,
            all: 1,
            type: searchInfo?.type === "all" ? null : searchInfo?.type || null,
            per_page: 25
        }
        if (!searchInfo?.all)
            query = {
                ...query,
                locked: searchInfo.isLock !== undefined ? +searchInfo.isLock : null,
            }
        getGhollaks(queryString(query), trigger !== null, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setGhollaks((prev) => ([...prev, ...data.data]));
                } else {
                    setGhollaks(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        })

    }, [page, trigger]);

    useEffect(() => {
        if (searchParams.get("update")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setCursor(null);
        }
    }, [searchParams.get("update")]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={ghollaks.length} next={fetchMoreData} hasMore={hasMore}>
                <GhollakTable data={ghollaks} setGhollaks={setGhollaks} searchInfo={searchInfo} onFilterClick={onFilterClick} handleFilterChange={handleChange} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
